/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { IUserWidgetProps } from './types';
import { CircularAvatar } from '../../../common/CustomAvatar';

export const UserWidget: FunctionComponent<IUserWidgetProps> = ({ user, onUserSelect }) => {
  const handleUserSelect = useCallback(() => onUserSelect(user.id), [user, onUserSelect]);

  return (
    <div className="contact-item" onClick={handleUserSelect}>
      <div className="contact-img">
        <CircularAvatar src={user.image} title={`${user.firstName} ${user.lastName}`} />
      </div>
      <div className="contact-name" style={{ paddingBottom: '4px' }}>
        {`${user.lastName}, ${user.firstName}`}
        <div className="contact-links">
          <a className="blueGray" title="">
            <i className="icon2-at"></i>
          </a>
          {/* <a className="blueGray" title="">
            <i className="icon2-slack"></i>
          </a> */}
          {/* <a className="blueGray" title="">
            <i className="icon2-hangouts"></i>
          </a> */}
        </div>
      </div>
    </div>
  );
};
